module.exports = __webpack_public_path__ + "static/media/clipping.29887d37.png";